<template lang="">
  <v-main>
    <template v-if="loading">
      <v-row justify="center" align-content="center" class="mt-10">
        <img src="../../assets/loading.gif">
      </v-row>
    </template>
  </v-main>
</template>

<script>
export default {
  name: 'GithubCallBack',
  data() {
    return {
      loading: true,
      height: window.innerHeight,
    }
  },
  async created() {
    await this.execAPI();
  },
  methods: {
    execAPI() {
      this.$store.dispatch(
        'auth/createGithubUer',
        this.$route.query
      );
      this.loading = false;
      const redirectUrl = this.$store.getters['auth/isNotLoginRedirectUrl'];
      if (redirectUrl) {
        this.$store.dispatch('auth/deleteForNotLoginRedirectUrl');
        return this.$router.push(redirectUrl)
      }
      this.$router.push('/')
    }
  },
}
</script>